module.exports = __webpack_public_path__ + "static/img/phone.9cdde202.png";